<template>
  <div :class="$style.icons">
      <SbpLogo />
  </div>
</template>

<script>
import SbpLogo from "../shapes/SbpLogo";

export default {
  name: "SbpPaymentBlockIcons",
  components: {
    SbpLogo
  }
};
</script>

<style lang="postcss" module>
  .icons {
      display: flex;
      margin-top: 0;
      align-items: center;
  }

  .icons > svg {
      width: 125px;
      height: 55px;
  }

  .icons > svg:not(:last-child) {
      margin-right: 12px;
  }
</style>
